module.exports = {"130773501":"榆树沟管理处","130773502":"沙梁子管理处","130773503":"小城子管理处","130773504":"东大门管理处"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130773.json
// module id = 286
// module chunks = 0